// extracted by css-extract-rspack-plugin
export default {"anchorWithScrollMargin":"OverviewMergeBox-module__anchorWithScrollMargin__z5hDD"};